/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { Layout, Button, Form } from 'antd';
import SearchBar from '../../components/Shared/searchbar/SearchBar';
import { PlusOutlined } from '@ant-design/icons';
import ListCard from './components/ListCard';
import { useTranslation } from 'react-i18next';
import ModalFail from '../../components/Shared/modal/fail';
import moment from 'moment';
import RopaService from '../../services/Ropa.service';
import UserService from '../../services/UserService';
import ModalActivity from './components/ModalActivity';
import ModalSuccess from '../../components/Shared/modal/success';
import { STATUS_ID } from './STATUS_ID';
import usePermission from '../../hooks/usePermission';

export default function RopaList() {
    // Role
    const role = UserService?.role()?.toLowerCase();
    const admin = role?.includes('admin');
    const { isAuditor } = usePermission();

    const [form] = Form.useForm();

    const { t, i18n } = useTranslation();
    const [currentPage, setCurrentPage] = useState({
        p: 1,
        ps: 10,
        s: 10,
        total: 0,
    });
    const [cardData, setCardData] = useState([]);

    const [openSuccess, setOpenSuccess] = useState(false);
    const [departmentList, setDepartmentList] = useState([]);
    const [searchValue, setSearchValue] = useState({});

    const [openActivityModal, setOpenActivityModal] = useState(false);
    const [statusType, setStatusType] = useState([]);
    const [openFail, setOpenFail] = useState(false);
    const initialStatus = [
        STATUS_ID.REVIEWED, //Reviewed
        STATUS_ID.DRAFT, //Draft
        STATUS_ID.REVISE, //Revise
        STATUS_ID.WAITING_FOR_REVIEW, //Waiting for Review
    ];

    const [checkedAll, setCheckedAll] = useState(false); // check Checkbox select all
    const [isCheckedAll, setIsCheckedAll] = useState(false); // check Select all {total} items in Primary

    const [allSelection, setAllSelection] = useState([]); // all select items ids
    const [select, setSelect] = useState([]); //select items ids
    const [dataSelection, setDataSelection] = useState([]);
    const [allDataSelection, setAllDataSelection] = useState([]);

    const [loading, setLoading] = useState(true);

    const getDepartment = async () => {
        try {
            let lang = i18n.language;
            const params = {
                s: lang === 'en' ? 'nameEn' : 'nameTh',
            };
            const { data } = await RopaService.getDepartmentList(params);
            if (data?.resultData) {
                let option = [];
                data?.resultData?.forEach((element) => {
                    option.push({
                        value: lang === 'en' ? element.nameEn : element.nameTh,
                        id: element.departmentId,
                    });
                });
                setDepartmentList(option);
                if (!admin) {
                    form.setFieldsValue({ departmentId: option[0].id });
                    searchRopaList({ departmentId: option[0].id }, currentPage);
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    const getStatus = async () => {
        try {
            let lang = i18n.language;
            const { data } = await RopaService.getStatus({
                type: 'ropa-activity',
            });
            if (data?.resultData) {
                let option = [];
                let initial = [];
                data?.resultData?.forEach((element) => {
                    option.push({
                        value: lang === 'en' ? element.nameEn : element.nameTh,
                        id: element.statusId,
                    });
                });
                option?.map((element) => initial.push(element.id));
                // setInitialStatus(initial)
                setStatusType(option || []);
            }
        } catch (err) {
            console.log(err);
        }
    };
    const searchRopaList = async (payload, pageValue) => {
        setLoading(true);
        try {
            const { data } = await RopaService.searchRopaList({
                departmentId: payload.departmentId ? payload.departmentId : '',
                activityName: payload.activityName ? payload.activityName : '',
                businessProcessName: payload.businessProcessName
                    ? payload.businessProcessName
                    : '',
                reviewBy: payload.reviewBy ? payload.reviewBy : '',
                status: payload.status
                    ? payload.status.join(',')
                    : initialStatus.join(','),
                startDate: payload?.requestDate
                    ? moment(payload.requestDate[0]).toISOString()
                    : '',
                endDate: payload?.requestDate
                    ? moment(payload.requestDate[1]).toISOString()
                    : '',
                p: pageValue.page ? pageValue.page : 1,
                ps: pageValue.pageSize ? pageValue.pageSize : 10,
                // s: 'modify_date',
                sd: 'DESC',
            });
            setLoading(false);
            setCardData(data?.resultData?.result || []);
            setCurrentPage({
                page: data?.resultData.page,
                pageSize: data?.resultData.pageSize,
                total: data?.resultData.total,
            });
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    useEffect(() => {
        getDepartment();
        getStatus();
    }, [i18n.language]);

    // Search Ropa

    useEffect(() => {
        if (loading) {
            searchRopaList(searchValue, currentPage);
        }
    }, [searchValue, currentPage.page, currentPage.pageSize]);

    useEffect(() => {
        if (openSuccess) {
            searchRopaList(searchValue, currentPage);
        }
    }, [openSuccess]);

    return (
        <Layout>
            <div className="title ">{t('RoPA.RecordOfProcessingActivity')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Data Inventory')} /{' '}
                </span>
                <span>{t('RoPA.RecordOfProcessingActivity')}</span>
            </div>
            <div className="content_">
                <div>
                    <SearchBar
                        className="w-full"
                        formRef={form}
                        loading={loading}
                        item={[
                            {
                                label: t('RoPA.Department'),
                                placeholder: t('dataFlow.SelectDepartment'),
                                name: 'departmentId',
                                type: 'Select',
                                option: departmentList,
                            },
                            {
                                label: t('Activity Name'),
                                placeholder: t('Search Activity Name'),
                                name: 'activityName',
                                type: 'Input',
                            },
                            {
                                label: t('dataFlow.BusinessProcess'),
                                placeholder: t(
                                    'dataFlow.SearchBusinessProcess'
                                ),
                                name: 'businessProcessName',
                                type: 'Input',
                            },
                            {
                                label: t('Reviewer'),
                                placeholder: t('Search Reviewer'),
                                name: 'reviewBy',
                                type: 'Input',
                            },
                            {
                                label: t('Update Date'),
                                placeholder: [t('Start date'), t('End date')],
                                name: 'requestDate',
                                type: 'RangePicker',
                            },
                            {
                                label: t('Status'),
                                name: 'status',
                                type: 'CheckboxByKey',
                                option: statusType,
                                initialValue: initialStatus,
                            },
                        ]}
                        onClear={() => {
                            setLoading(true);
                            setSearchValue({
                                status: initialStatus,
                            });
                            setSelect([]);
                            setDataSelection([]);
                            setAllSelection([]);
                            setAllDataSelection([]);
                            setCheckedAll(false);
                            setIsCheckedAll(false);
                            setCurrentPage({
                                ...currentPage,
                                page: 1,
                            });
                        }}
                        onFinish={(e) => {
                            setLoading(true);
                            setSearchValue({
                                ...e,
                            });
                            setSelect([]);
                            setDataSelection([]);
                            setAllSelection([]);
                            setAllDataSelection([]);
                            setCheckedAll(false);
                            // setIsCheckedAll(false)
                            setCurrentPage({
                                ...currentPage,
                                page: 1,
                            });
                        }}
                    />
                </div>
                <div className="w-full">
                    <div className="flex py-2 px-4">
                        <div className="flex-1">
                            <div className="text-xl font-medium">
                                {t('RoPA.TitleRoPA')}
                            </div>
                            <div className="text-xs font-normal text-gray-PHX mt-1">
                                {t('RoPA.DesTitleRoPA')}
                            </div>
                            <div className="text-xs font-semibold text-gray-PHX mt-4">
                                {t('TotalItems', {
                                    length: currentPage.total,
                                })}
                            </div>
                        </div>
                        <div>
                            <Button
                                disabled={isAuditor}
                                className="w-full px-10"
                                size="large"
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => setOpenActivityModal(true)}
                            >
                                {t('RoPA.AddActivity')}
                            </Button>
                        </div>
                    </div>
                    <div>
                        <ListCard
                            search={() =>
                                searchRopaList(searchValue, currentPage)
                            }
                            select={select}
                            setSelect={setSelect}
                            dataSelection={dataSelection}
                            setDataSelection={setDataSelection}
                            checkedAll={checkedAll}
                            setCheckedAll={setCheckedAll}
                            isCheckedAll={isCheckedAll}
                            setIsCheckedAll={setIsCheckedAll}
                            allDataSelection={allDataSelection}
                            setAllDataSelection={setAllDataSelection}
                            setAllSelection={setAllSelection}
                            allSelection={allSelection}
                            setLoading={setLoading}
                            total={currentPage.total}
                            dataSource={cardData}
                            setCurrentPage={setCurrentPage}
                            currentPage={currentPage}
                            loadingData={loading}
                        />
                    </div>
                </div>
            </div>

            <ModalActivity
                mode="addActivity"
                search={() => searchRopaList(searchValue, currentPage)}
                open={openActivityModal}
                setOpenSuccess={setOpenSuccess}
                handelClose={() => {
                    setOpenActivityModal(false);
                }}
            />

            <ModalFail
                text={''}
                open={openFail}
                handelClose={() => setOpenFail(false)}
            />

            <ModalSuccess
                open={openSuccess}
                text={t('RoPA.SuccessfullyAddData')}
                handelClose={() => setOpenSuccess(false)}
            />
        </Layout>
    );
}
